import Icon from '@mdi/react'
import { mdiPartyPopper } from '@mdi/js'

const PartyPopperIcon = ({ color, size = 1.75 }) => (
  <Icon path={mdiPartyPopper} color={color ?? '#00234b'} size={size} />
)

export default PartyPopperIcon
